import React, { useEffect, useState } from "react";
import { getPermissions } from "../utilities/genesysCloudUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Permissions({
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    setPageNumber(1)
    setTabName("permissions-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getPermissions().then((data) => {
      setPermissions(data.entities);
      setPageCount(data.pageCount);
    });
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const permissionMaps = permissions.flatMap((permission) =>
    Object.values(permission.permissionMap || {}).flat()
  );
  const getPermissionId = (permission) =>
    [permission.domain, permission.entityType, permission.action].join(":");
  const allVisibleSelected = permissionMaps.length > 0 && permissionMaps.every(
    (permission) => selectedExportRows[getPermissionId(permission)]
  );

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: permissionMaps })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(permissionMaps, checked)}
      rowCount={permissionMaps.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Permissions"
    >
      {permissions ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                {/* <th>Count</th> */}
                <th>Domain</th>
                <th>Entity Type</th>
                <th>Action</th>
                <th>Description</th>
                <th>Allow Conditions?</th>
                <th>Division-Aware?</th>
              </tr>
            </thead>
            <tbody>
              {permissionMaps.map((permissionMap) => {
                return (
                    <tr key={getPermissionId(permissionMap)}>
                      <td className="select-column">
                        <input
                          aria-label={`Select ${permissionMap.domain} for export`}
                          checked={Boolean(selectedExportRows[getPermissionId(permissionMap)])}
                          onChange={(event) => onToggleExportRow(permissionMap, event.target.checked)}
                          type="checkbox"
                        />
                      </td>
                      <th>
                        {permissionMap.domain}
                      </th>
                      <td>
                        {permissionMap.entityType}
                      </td>
                      <td>
                        {permissionMap.action}
                      </td>
                      <td>
                        {permissionMap.label}
                      </td>
                      <td>
                        {permissionMap.allowsConditions ? "true" : "false"}
                      </td>
                      <td>
                        {permissionMap.divisionAware ? "true" : "false"}
                      </td>
                    </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
